import { put, takeLatest } from 'redux-saga/effects';
import { goBack, push } from 'connected-react-router';
import {
  GO_BACK_ACTION, REDIRECTION_ACTION,
  RESET_TO_HOME_ACTION,
} from '../actions/redirect';
import { safe } from './util';


function* redirect({ type, location }) {
  switch (type) {
    case GO_BACK_ACTION:
      yield put(goBack());
      break;
    case REDIRECTION_ACTION:
      yield put(push(location));
      break;
    case RESET_TO_HOME_ACTION:
      // yield put(push('/'));
      window.location = '/';
      break;
    default:
      console.warn(`unknown action ${type} delivered to redirect saga`);
      break;
  }
}

export function* watchRedirect() {
  yield takeLatest([REDIRECTION_ACTION, GO_BACK_ACTION, RESET_TO_HOME_ACTION], safe(redirect));
}



// WEBPACK FOOTER //
// ./src/sagas/redirect.js